// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","image":"Logo_image__tPBw4"};